
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import React from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const SavingsCalculatorPage = lazy(() => import('../pages/savings-calculator/page'));
const ProtectionPlansPage = lazy(() => import('../pages/protection-plans/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Routes configuration for the application.
 * Each route lazily loads its component to improve initial bundle size.
 * A fallback route (`*`) catches all undefined URLs and shows a 404 page.
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/savings-calculator',
    element: <SavingsCalculatorPage />,
  },
  {
    path: '/protection-plans',
    element: <ProtectionPlansPage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
